interface PersonFocusedSVGProps {
  color: string;
  style: React.CSSProperties;
}

const PersonFocusedSVG = ({ color, style }: PersonFocusedSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="55"
    height="50"
    viewBox="0 0 55 50"
    fill="none"
  >
    <g clipPath="url(#clip0_3349_71084)">
      <path
        d="M33.6094 18.9473C33.6094 18.9473 39.7357 22.2705 42.1203 24.1857C42.6911 24.6423 43.1604 25.2004 43.5536 25.8093C44.2765 26.9508 44.6063 28.2953 44.6063 29.6525V35.5632"
        stroke={color}
        strokeWidth="1.4206"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M21.2548 18.9473C21.2548 18.9473 15.1284 22.2705 12.7439 24.1857C12.1731 24.6423 11.7038 25.2004 11.3106 25.8093C10.5876 26.9508 10.2578 28.2953 10.2578 29.6525V35.5632H44.5932"
        stroke={color}
        strokeWidth="1.4206"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M27.4317 22.1702C32.2092 22.1702 36.0821 17.3659 36.0821 11.4396C36.0821 5.51324 32.2092 0.708984 27.4317 0.708984C22.6542 0.708984 18.7812 5.51324 18.7812 11.4396C18.7812 17.3659 22.6542 22.1702 27.4317 22.1702Z"
        stroke={color}
        strokeWidth="1.4206"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M44.5959 33.5859V35.5773H42.6172H44.5959V33.5859Z"
        stroke={color}
        strokeWidth="1.4206"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M44.8711 0.708984H54.1557V9.98093"
        stroke={color}
        strokeWidth="1.4206"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M9.97897 49.2885H0.707031V40.0039"
        stroke={color}
        strokeWidth="1.4206"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M54.1557 40.0039V49.2885H44.8711"
        stroke={color}
        strokeWidth="1.4206"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M0.707031 9.98093V0.708984H9.97897"
        stroke={color}
        strokeWidth="1.4206"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <circle cx="54.1595" cy="14.598" r="0.710299" fill={color} />
      <path
        d="M54.1562 17.998V33.3075"
        stroke={color}
        strokeWidth="1.4206"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <circle cx="54.1595" cy="35.0189" r="0.710299" fill={color} />
      <circle cx="0.706393" cy="14.598" r="0.710299" fill={color} />
      <path
        d="M0.703125 17.998V33.3075"
        stroke={color}
        strokeWidth="1.4206"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <circle cx="0.706393" cy="35.0189" r="0.710299" fill={color} />
      <path
        d="M35.9242 40.4355H18.9531"
        stroke={color}
        strokeWidth="1.4206"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.7637 44.9131H23.1133"
        stroke={color}
        strokeWidth="1.4206"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.9114 49.0605H25.9688"
        stroke={color}
        strokeWidth="1.4206"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3349_71084">
        <rect width="54.8706" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default PersonFocusedSVG;
